import React from "react";
import { Link } from "react-router-dom";
import { ErrorCircle } from "@styled-icons/boxicons-regular/ErrorCircle";
import * as ROUTES from "../../constants/routes";
import { TopBanner } from "../TopBanner";

const WeakPasswordBanner = () => (
  <TopBanner>
    <div>
      <ErrorCircle />
      <h5>Your password no longer meets our password requirements.</h5>
      <Link to={ROUTES.USER_PROFILE}>Update password</Link>
    </div>
  </TopBanner>
);

export default WeakPasswordBanner;
